import { convertToRaw } from 'draft-js'
import { draftToMarkdown } from 'markdown-draft-js'
import buildValidUrlFromContentState from './build-valid-url'

const editorStateToMarkdown = (editorState, draftToMarkdownOptions = {}) => {
  const content = buildValidUrlFromContentState(
    convertToRaw(editorState.getCurrentContent()),
  )
  return draftToMarkdown(content, draftToMarkdownOptions)
}

export default editorStateToMarkdown
